import {createFileRoute} from '@tanstack/react-router';

import AdminInviteAcceptView from '../user/AdminInviteAcceptView.tsx';

export const Route = createFileRoute('/admin-invite/$token')({
    component: RouteComponent,
});

function RouteComponent() {
    return <AdminInviteAcceptView />;
}
